import { Toast } from '@base-ui/react/toast';
import { FC, useEffect, useId } from 'react';

import { useErrorMessage } from '../hooks/useErrorMessage';

interface ErrorSnackbarProps {
  error: unknown;
  onClose: () => void;
}

const ToastList: FC = () => {
  const { toasts } = Toast.useToastManager();

  return toasts.map(toast => (
    <Toast.Root
      key={toast.id}
      toast={toast}
      swipeDirection="right"
      className="flex max-w-xl font-sans"
    >
      <Toast.Content className="flex gap-4 overflow-hidden rounded-lg border border-solid border-slate-200 bg-white p-3 text-start text-slate-900 shadow-md dark:border-slate-700 dark:bg-slate-900 dark:text-slate-50">
        <div className="max-w-full flex-1">
          <Toast.Title className="m-0 mr-2 font-medium leading-normal" />
          <Toast.Description className="m-0 font-normal leading-normal text-slate-800 dark:text-slate-400" />
        </div>
      </Toast.Content>
    </Toast.Root>
  ));
};

export const ErrorSnackbar: FC<ErrorSnackbarProps> = ({ error, onClose }) => {
  const { add } = Toast.useToastManager();
  const toastId = useId();
  const { title, message } = useErrorMessage(error) ?? {};

  useEffect(() => {
    add({
      id: toastId,
      title,
      description: message,
      timeout: 5000,
      priority: 'high',
      onClose
    });
  }, [add, message, onClose, title, toastId]);

  return (
    <Toast.Portal>
      <Toast.Viewport className="fixed bottom-4 left-auto right-4 z-50">
        <ToastList />
      </Toast.Viewport>
    </Toast.Portal>
  );
};
